<template>
  <div class="home">

    <div v-if="textAreaJsonUsed">
      <textarea cols="30" rows="10" v-model="textAreaJson"></textarea><br/>
      <button @click="controlJsonArea(false)">입력창 닫기</button>
    </div>
    <button @click="inOutJson(true)">json불러오기</button> <button @click="inOutJson(false)">json가져오기</button>

    <hr>

    <h2>입력</h2>
    <table border="1" class="WageTabe">
      <!-- 시급 -->
      <tr>
        <td colspan="7">시급 : <input type="number" v-model="hourlyWage">원</td>
      </tr>
      <!-- 월 -->
      <tr>
        <td colspan="7"><input id="inputMonth" type="month" v-model="month"></td>
      </tr>
      <!-- 요일 -->
      <tr>
        <td>월</td>
        <td>화</td>
        <td>수</td>
        <td>목</td>
        <td>금</td>
        <td style="color: blue;">토</td>
        <td style="color: red;">일</td>
      </tr>
      <tr :key="j" v-for="(inputTiem, j) in warkWeekTime">
        <td>
          <table>
            <tr>
              <td>
                <a v-if="showDate[j * 7] - this.getWeekFirstDay <= 0"></a>
                <a v-else-if="showDate[j * 7] - this.getWeekFirstDay > this.getWeekLastDay"></a>
                <a v-else>{{showDate[j * 7] - this.getWeekFirstDay}}</a>
              </td>
            </tr>
            <tr>
              <td>
                <input type="number" v-model="warkTime[(j * 7)]" @blur="nonMinus(j * 7)" @click="clearInput(j * 7)" v-if="showDate[j * 7] - this.getWeekFirstDay > 0 && showDate[j * 7] - this.getWeekFirstDay <= this.getWeekLastDay"/>
              </td>
            </tr>
          </table>
        </td>
        <td>
          <table>
            <tr>
              <td>
                <a v-if="showDate[j * 7] + 1 - this.getWeekFirstDay <= 0"></a>
                <a v-else-if="showDate[j * 7] + 1 - this.getWeekFirstDay > this.getWeekLastDay"></a>
                <a v-else>{{showDate[j * 7] + 1 - this.getWeekFirstDay}}</a>
              </td>
            </tr>
            <tr>
              <td><input type="number" v-model="warkTime[(j * 7) + 1]" @blur="nonMinus(j * 7 + 1)" @click="clearInput(j * 7 + 1)" v-if="showDate[j * 7] + 1 - this.getWeekFirstDay > 0 && showDate[j * 7] + 1 - this.getWeekFirstDay <= this.getWeekLastDay"/></td>
            </tr>
          </table>
        </td>
        <td>
          <table>
            <tr>
              <td>
                <a v-if="showDate[j * 7] + 2 - this.getWeekFirstDay <= 0"></a>
                <a v-else-if="showDate[j * 7] + 2 - this.getWeekFirstDay > this.getWeekLastDay"></a>
                <a v-else>{{showDate[j * 7] + 2 - this.getWeekFirstDay}}</a>
              </td>
            </tr>
            <tr>
              <td><input type="number" v-model="warkTime[(j * 7) + 2]" @blur="nonMinus(j * 7 + 2)" @click="clearInput(j * 7 + 2)" v-if="showDate[j * 7] + 2 - this.getWeekFirstDay > 0 && showDate[j * 7] + 2 - this.getWeekFirstDay <= this.getWeekLastDay"/></td>
            </tr>
          </table>
        </td>
        <td>
          <table>
            <tr>
              <td>
                <a v-if="showDate[j * 7] + 3 - this.getWeekFirstDay <= 0"></a>
                <a v-else-if="showDate[j * 7] + 3 - this.getWeekFirstDay > this.getWeekLastDay"></a>
                <a v-else>{{showDate[j * 7] + 3 - this.getWeekFirstDay}}</a>
              </td>
            </tr>
            <tr>
              <td><input type="number" v-model="warkTime[(j * 7) + 3]" @blur="nonMinus(j * 7 + 3)" @click="clearInput(j * 7 + 3)" v-if="showDate[j * 7] + 3 - this.getWeekFirstDay > 0 && showDate[j * 7] + 3 - this.getWeekFirstDay <= this.getWeekLastDay"/></td>
            </tr>
          </table>
        </td>
        <td>
          <table>
            <tr>
              <td>
                <a v-if="showDate[j * 7] + 4 - this.getWeekFirstDay <= 0"></a>
                <a v-else-if="showDate[j * 7] + 4 - this.getWeekFirstDay > this.getWeekLastDay"></a>
                <a v-else>{{showDate[j * 7] + 4 - this.getWeekFirstDay}}</a>
              </td>
            </tr>
            <tr>
              <td><input type="number" v-model="warkTime[(j * 7) + 4]" @blur="nonMinus(j * 7 + 4)" @click="clearInput(j * 7 + 4)" v-if="showDate[j * 7] + 4- this.getWeekFirstDay > 0 && showDate[j * 7] + 4 - this.getWeekFirstDay <= this.getWeekLastDay"/></td>
            </tr>
          </table>
        </td>
        <td>
          <table>
            <tr>
              <td>
                <a v-if="showDate[j * 7] + 5 - this.getWeekFirstDay <= 0"></a>
                <a v-else-if="showDate[j * 7] + 5 - this.getWeekFirstDay > this.getWeekLastDay"></a>
                <a style="color: blue;" v-else>{{showDate[j * 7] + 5 - this.getWeekFirstDay}}</a>
              </td>
            </tr>
            <tr>
              <td><input type="number" v-model="warkTime[(j * 7) + 5]" @blur="nonMinus(j * 7 + 5)" @click="clearInput(j * 7 + 5)" v-if="showDate[j * 7] + 5 - this.getWeekFirstDay > 0 && showDate[j * 7] + 5 - this.getWeekFirstDay <= this.getWeekLastDay"/></td>
            </tr>
          </table>
        </td>
        <td>
          <table>
            <tr>
              <td>
                <a v-if="showDate[j * 7] + 6 - this.getWeekFirstDay <= 0"></a>
                <a v-else-if="showDate[j * 7] + 6 - this.getWeekFirstDay > this.getWeekLastDay"></a>
                <a style="color: red;" v-else>{{showDate[j * 7] + 6 - this.getWeekFirstDay}}</a>
              </td>
            </tr>
            <tr>
              <td><input type="number" v-model="warkTime[(j * 7) + 6]" @blur="nonMinus(j * 7 + 6)" @click="clearInput(j * 7 + 6)" v-if="showDate[j * 7] + 6 - this.getWeekFirstDay > 0 && showDate[j * 7] + 6 - this.getWeekFirstDay <= this.getWeekLastDay"/></td>
            </tr>
          </table>
        </td>
      </tr>
    </table>

    <hr>

    <h2>결과</h2>
    <div :key="k" v-for="(WeekTime, k) in warkWeekTime">
      <a v-if="WeekTime != 0">
        {{k + 1}}주에는 {{WeekTime}}시간 근무 했습니다.<br/>
        주휴수당은 {{warkWeekPlusTime[k]}}시간 입니다.<br/><br/>
      </a>
    </div>
    <br/>
    <p>순수 총 근무는 {{totalWarkTime}}시간 | {{(totalWarkTime * hourlyWage).toLocaleString()}}원 입니다.</p>
    <p>주휴는 {{totalWarkWeekPlusTime}}시간 | {{(totalWarkWeekPlusTime * hourlyWage).toLocaleString()}}원 입니다.</p>
    <p>총합은 {{(parseFloat(totalWarkTime) + parseFloat(totalWarkWeekPlusTime)).toFixed(1)}}시간 | {{(parseFloat((parseFloat(totalWarkTime) + parseFloat(totalWarkWeekPlusTime)).toFixed(1)) * hourlyWage).toLocaleString()}}원 입니다.</p>
  </div>
</template>

<style>
  .WageTabe {
    margin: 0 auto;
  }
  .WageTabe input {
    width: 100px;
    text-align: center;
  }

  #inputMonth {
    width: 200px;
  }

  input[type="number"]::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
</style>

<script>
import { getCurrentInstance } from '@vue/runtime-core';
// import axios from 'axios'

export default {
  data() {
    return {
      month:"",
      showDate:[],
      warkTime:[],
      warkWeekTime:[],
      warkWeekPlusTime:[],
      hourlyWage:9160,
      textAreaJson:"",
      textAreaJsonUsed:false,
      app:"",
      socket:"",
    }
  },

  methods: {
    nonMinus(i) {
      console.log("call method nonMinus " + i);

      if(this.warkTime[i] < 0 || this.warkTime[i] > 24) {
        alert("0 ~ 24 사이로 설정 해주세요.")
        this.warkTime[i] = 0;
      }

      try {
        if(this.warkTime[i].trim() == "") {
          this.warkTime[i] = 0;
        } else {
          this.warkTime[i] = 0;
        }
        alert("문자가 입력 되어있습니다.");
      } catch (error) {
        console.log("입력항목 검사 완료");
      }

      for(let k = 0; k <= 41; k++) {
        let j = parseInt(k / 7);
        if(k % 7 == 0) {
          this.warkWeekTime[j] = this.warkTime[k];
        }
        else {
          this.warkWeekTime[j] += this.warkTime[k];
        }
        if(this.warkWeekTime[j] >= 15) {
          this.warkWeekPlusTime[j] = parseFloat((this.warkWeekTime[j] * 0.2).toFixed(1));
        }
      }
      console.log("end to nonMinus " + i);
    },

    // 칸 빈칸으로
    clearInput(i) {
      console.log("call method clearInput " + i);
      this.warkTime[i] = "";
    },

    // json 입력칸 제어
    controlJsonArea(i) {
      console.log("call method controlJsonArea : " + i);
      this.textAreaJsonUsed=i;
    },

    // json 저장, 열기
    inOutJson(i) {
      console.log("call method inOUtJson : " + i);
      this.controlJsonArea(true);

      let wageJson;
      let date;

      function dateCustonSort(a, b) {
        if(a.date == b.date){ return 0} return  a.date < b.date ? -1 : 1;
      }

      // 저장
      if(i) {
        wageJson = new Object();
        date = new Array();

        wageJson.month = this.month;

        for(var j = 0; j < this.warkTime.length; j++) {
          var day = new Object();
          
          day.date = j;
          day.warkTime = this.warkTime[j];

          date.push(day);
        }

        wageJson.date = date;

        this.textAreaJson = JSON.stringify(wageJson);
      } 
      // 불러오기
      else {
        if(this.textAreaJson == "") return;

        try {
          wageJson = JSON.parse(this.textAreaJson);
        } catch (error) {
          alert("형식이 일치하지 않습니다.");
          return;
        }

        this.month = wageJson.month;
        date = wageJson.date;

        date.sort(dateCustonSort);

        for(let j = 0; j < date.length; j++) {
          if(date[j].date != j) {
            alert(j + "번 json 오류!\n값 : " + date[j].date);
            return;
          } else if(date[j].warkTime < 0 || date[j].warkTime > 24) {
            alert(j + "번 json 근무시간 오류\n값 : " + date[j].warkTime);
            return;
          }
        }

        for(let j = 0; j < date.length; j++) {
          this.warkTime[j] = date[j].warkTime;
        }
      }
    },
  },

  created() {
    console.log("==========================");
    console.log("페이지 준비중!");
    console.log("==========================");
    this.app = getCurrentInstance();
    this.socket = this.app.appContext.config.globalProperties.$socket;
    let tempYear = new Date().getFullYear();
    let tempMonth = new Date().getMonth() + 1;
    if(tempMonth < 10) {
      tempMonth = "0" + tempMonth;
    }
    this.month = tempYear + "-" + tempMonth;
    console.log("현재 날짜 입력 완료!")
    for(let i = 0; i < 42; i++) {
      this.warkTime[i] = 0;
      this.showDate[i] = i + 1;
    }
    console.log("근무시간 배열 준비 완료!");
    for(let i = 0; i < 6; i++) {
      this.warkWeekTime[i] = 0;
    }
    console.log("주 근무 시간 배열 준비 완료!");
    for(let i = 0; i < 6; i++) {
      this.warkWeekPlusTime[i] = 0;
    }
    console.log("주휴 시간 배열 준비 완료!");
    console.log("==========================");
    console.log("페이지 준비 완료!");
    console.log("==========================");
  },
  
  computed: {
    getWeekFirstDay() {
      console.log("call computed getWeekFirstDay : " + this.month);
      let i = new Date(this.month + "-01").getDay();
      i = i - 1;
      if(i == -1) i = 6;
      return i;
    },

    getWeekLastDay() {
      console.log("call computed getWeekLastDay : " + this.month);
      let temp = this.month.split("-");
      if(temp[1] == 2) {
        if(temp[0] % 4 == 0) {
          return "29";
        } else {
          return "28";
        }
      } else if(temp[1] == 4 || temp[1] == 6 || temp[1] == 9 || temp[1] == 11) {
        return "30";
      } else {
        return "31";
      }
    },

    // 근무 시간 총합
    totalWarkTime() {
      console.log("call computed totalWarkTime");
      let temp = 0;
      for(let i = 0; i < this.warkWeekTime.length; i++) {
        temp += this.warkWeekTime[i];
      }
      return temp;
    },

    // 주휴 시간 총합
    totalWarkWeekPlusTime() {
      console.log("call computed totalWarkWeekPlusTime");
      let temp = 0;
      for(let i = 0; i < this.warkWeekPlusTime.length; i++) {
        temp += this.warkWeekPlusTime[i];
      }
      return temp.toFixed(1);
    }
  },
}
</script>
